let audioUnlocked = false;

/**
 * Prime audio during a user gesture (e.g. login submit). Uses muted playback
 * so nothing is heard; later notification plays can use normal volume.
 */
export function unlockNotificationAudioSilently(audio) {
  if (!audio || audioUnlocked) return;

  const previousMuted = audio.muted;
  audio.muted = true;
  audio.currentTime = 0;

  const playPromise = audio.play();
  if (playPromise === undefined) {
    audio.muted = previousMuted;
    return;
  }

  playPromise
    .then(() => {
      audio.pause();
      audio.currentTime = 0;
      audio.muted = previousMuted;
      audioUnlocked = true;
    })
    .catch(() => {
      audio.muted = previousMuted;
    });
}

/**
 * For users already logged in (session persisted). On the first click or keypress
 * in the app, silently prime audio — nothing is heard.
 */
export function setupNotificationAudioUnlockOnFirstInteraction(audio) {
  if (!audio || audioUnlocked) return;

  const onInteraction = () => {
    unlockNotificationAudioSilently(audio);
    document.removeEventListener("click", onInteraction);
    document.removeEventListener("keydown", onInteraction);
  };

  document.addEventListener("click", onInteraction);
  document.addEventListener("keydown", onInteraction);
}

/** Play notification sound; ignores autoplay blocks without throwing. */
export function playNotificationSound(audio) {
  if (!audio) return;

  audio.currentTime = 0;
  const playPromise = audio.play();
  if (playPromise !== undefined) {
    playPromise.catch(() => {});
  }
}
